<template lang="pug">
pr-wrapper.dropdown.animated(bg, :bgo="this.isInput ? '0.5' : '0'", fs, :zi="index", v-visible="activated")
  pr-wrapper.animated(
    bg="darken",
    zi="1",
    v-nv:scope="'dropdown'",
    data-scroll="center",
    ref="dropdown",
    nv-sleep-protect,
    nv-exit-protect,
    @nv-exit.native="close",
    @nv-back.native="close"
  )
    .scroll-container.position-relative
      .option.text-muted.px-4.py-3(
        v-nv="option.selected || false",
        @nv-enter="select(option.key)",
        v-for="option in payload.data",
        :key="option.key",
        :class="optionClass"
      ) 
        pr-text(weight="semibold") {{ option.value }}
</template>

<script>
export default {
  name: "dropdown",
  data() {
    return {
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    isInput() {
      return this.payload.type === "input"
    },
    optionClass() {
      return this.isInput ? "background" : "themed scale-sm"
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "105" : "0"
    }
  },
  mounted() {
    _$.vue.$on("dropdown", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()

      if (!this.validatePayload(payload)) return false
      if (this.activated) this.payload.reject()

      this.payload = payload

      await this.$nextTick()
      await this.setDisplayMetrics()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }

      await _$.nav.sync("dropdown", true).then(() => this.payload.target.classList.add("nv-el-current"))
      await _$.sleep(200)
      this.activated = true
    },
    async setDisplayMetrics() {
      const rect = this.payload.target.getBoundingClientRect()

      let styles,
        left = 0,
        el = this.$refs.dropdown.$el
      if (this.isInput) {
        left = Math.floor(rect.left + rect.width / 2)
        styles = {
          bottom: null,
          top: null,

          maxWidth: Math.floor(rect.width - this.payload.offset * 2) + "px",
          maxHeight: 5 * 53 + "px",
          overflow: "hidden",
          borderRadius: "5px"
        }
      } else {
        left = Math.floor(rect.left + rect.width / 2)
        styles = {
          bottom: null,
          top: null,

          maxWidth: null,
          maxHeight: null,
          overflow: "unset",
          borderRadius: null
        }
      }

      left -= el.offsetWidth / 2

      if (left + el.offsetWidth > window.innerWidth) left -= left + el.offsetWidth - window.innerWidth + 20
      else if (left < 0) left += 0 - left - 20

      styles.left = left + "px"

      if (rect.top > window.innerHeight - rect.bottom) styles.bottom = window.innerHeight - rect.top + 5 + "px"
      else styles.top = rect.bottom + 5 + "px"

      Object.assign(el.style, styles)

      return true
    },
    validatePayload(payload) {
      let validate = true

      if (typeof payload !== "object") validate = false
      else if (!payload.data || !payload.target || !payload.resolve || !payload.reject) validate = false
      else if (!Array.isArray(payload.data)) validate = false
      else if (typeof payload.resolve !== "function") validate = false
      else if (typeof payload.reject !== "function") validate = false

      if (!validate && typeof payload === "object" && payload.reject) payload.reject()

      return validate
    },
    select(result) {
      this.close(true, result)
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) this.payload.resolve(resolve)
      else this.payload.reject()

      this.payload = {}

      if (resolve) return resolve
      else return false
    }
  }
}
</script>

<style lang="scss" scoped>
#dropdown {
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);
  display: inline-block;
  overflow: unset;
  position: absolute;
  .scroll-container {
    .option {
      white-space: nowrap;
      &.nv-el-current {
        .text-muted {
          color: white !important;
        }
      }
    }
  }
}
</style>
